<ng-container *transloco="let t; prefix: scope">
  <div class="mb-2">
    <bl-frontend-button (onclick)="showNewTodo()" [text]="t('createNewNote')"></bl-frontend-button>
  </div>

  <app-table
    [columns]="columns$ | async"
    [data]="clientTodos$ | async"
    [paginator]="false"
    scrollHeight="615px"
    [columnSelector]="false"
    [useFixedStyle]="true">
    <ng-template tableTemplate="bodyCell" tableBodyCellField="default" let-content let-todo="rowData">
      <a (click)="showExistingTodo(todo)" class="text-black cursor-pointer">{{ content }}</a>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="type" let-content let-todo="rowData">
      <a (click)="showExistingTodo(todo)" class="text-black cursor-pointer">{{
        content | pickTodoTypeDescription | async
      }}</a>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="assignment" let-content let-todo="rowData">
      <a (click)="showExistingTodo(todo)" class="text-black cursor-pointer">{{
        content | pickAssignmentName | async
      }}</a>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="entryDate" let-content let-rowData="rowData">
      <a (click)="showExistingTodo(rowData)" class="text-black cursor-pointer">{{ toLocalDateFormat(content) }}</a>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="deadline" let-content let-rowData="rowData">
      <a (click)="showExistingTodo(rowData)" class="text-black cursor-pointer">{{ toLocalDateFormat(content) }}</a>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="status" let-composite="rowData">
      <app-todo-status-selector
        [selectedStatus]="composite.state"
        (selectedStatusChange)="changeStateAndSave($event, composite)"
        [disabled]="isDisabledSelector(composite)"
        [title]="isDisabledSelector(composite) ? t('note') : t('selectStatus')"
        styleClass="w-full table-inline-dropdown"></app-todo-status-selector>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="action" let-todo="rowData">
      <span *ngIf="!client.archived" (click)="tryDeleteTodo(todo)" class="far fa-trash-alt cursor-pointer text-center">
      </span>
    </ng-template>

    <ng-template tableTemplate="emptyMessage"> {{ t('noNotesToShow') }} </ng-template>
    <ng-template tableTemplate="summary" let-data> {{ t('numberOfNotes', { count: data.length }) }} </ng-template>
  </app-table>

  <p-dialog
    [header]="t('doYouWantToDeleteNote')"
    [(visible)]="displayDeleteDialog"
    showEffect="fade"
    [closeOnEscape]="false"
    [closable]="false"
    [style]="{ width: '400px' }"
    [draggable]="false">
    <p>{{ t('noteWillBePermanentRemoved') }}</p>
    <p>{{ t('doYouWantToContinue') }}</p>
    <p-footer>
      <bl-frontend-button variant="secondary-negative" (onclick)="afterDeleteDialog(false)" [text]="'shared.no' | transloco"></bl-frontend-button>
      <bl-frontend-button (onclick)="afterDeleteDialog(true)" [text]="'shared.yes' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog>
</ng-container>
